import primaryButton from './primary-button';
import featureNumber from './feature-number';
import text from './text';
import link from './link';
import icon from './icon';
import input from './input';
import priceText from './price-text';
import surface from './surface';
import headerPhoneNumber from './header-phone-number';
import errorMessages from './error-messages';
import successMessages from './success-messages';
import checkbox from './checkbox';
import priceLabel from './price-label';
import secondaryButton from './secondary-button';
import radio from './radio';
import headerSocialIcons from './header-social-icons';
import table from './table';
import navigation from './navigation';
import dropdown from './dropdown';
import filePicker from './file-picker';
import focusBorder from './focus-border';
import schedule from './schedule';
import timePicker from './time-picker';
import datePicker from './date-picker';
import textHighlight from './text-highlight';
import tag from './tag';
import decoration from './decoration';

export default {
  primaryButton,
  featureNumber,
  text,
  link,
  icon,
  input,
  priceText,
  surface,
  headerPhoneNumber,
  errorMessages,
  successMessages,
  checkbox,
  priceLabel,
  secondaryButton,
  radio,
  headerSocialIcons,
  table,
  navigation,
  dropdown,
  filePicker,
  focusBorder,
  datePicker,
  textHighlight,
  timePicker,
  tag,
  schedule,
  decoration,
};
